var map = {
	"./Appearance/config/sidebar.js": 519,
	"./Assessment/config/sidebar.js": 520,
	"./Course/config/sidebar.js": 521,
	"./Dashboard/config/sidebar.js": 522,
	"./Settings/config/sidebar.js": 523,
	"./User/config/sidebar.js": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 518;